module.exports = __webpack_public_path__ + "static/appstore-d2886105aa192f09d0a9a9bb72b6170f.svg";